import React from 'react';
import strings from '../../lang/strings.js';
import { PageSettings } from "../../config/page-settings.js";
import { withRouter } from 'react-router-dom';
import { inject } from 'mobx-react';
import { Panel, PanelBody, PanelHeader } from '../../components/panel/panel.jsx';
import DataTable from '../../components/content/data-table.jsx';
import SearchInput from '../../components/content/search-input.js';
import SearchSelect from '../../components/content/search-select.js';
import $ from 'jquery';
import '../../config/util.js';
import Const from '../../config/const.js';
import MemberDetailPopup from '../member-detail/member-detail-popup.js';
const queryString = require('query-string');

class EventJoin extends React.Component {
    static contextType = PageSettings;

    constructor(props) {
        super(props);

        let searchQS = queryString.parse(this.props.location.search);

        this.state = {
            search_info: searchQS,
            show_member_profile: false,
            selected_uid: 0
        };

        this.refreshTable = this.refreshTable.bind(this);
    }

    componentDidMount() {
        let self = this;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.location.search != this.props.location.search) {
            let searchQS = queryString.parse(this.props.location.search);
            this.setState({ search_info: searchQS }, () => this.refreshTable());
        }
    }

    refreshTable = (refresh) => {
        this.tblMember.draw(refresh);
    };

    searchTable = () => {
        let searchQS = queryString.parse(this.props.location.search);
        Object.assign(searchQS, this.state.search_info)
        const new_query = queryString.stringify(searchQS);
        if (new_query == this.props.location.search.substr(1)) {
            this.refreshTable();
        } else {
            this.props.history.push('?' + new_query);
        }
    }

    showMemberDetailPopup(uid) {
        this.setState({
            show_member_profile: true,
            selected_uid: uid
        });
    }

    render() {
        let self = this;
        let columnNo = 0;
        const { search_info } = this.state;

        return (
            <div>
                <Panel>
                    <PanelHeader noButton={true}>이벤트 참여목록</PanelHeader>
                    <PanelBody>
                        <MemberDetailPopup isOpen={this.state.show_member_profile} uid={this.state.selected_uid} onClose={() => {
                            this.setState({ show_member_profile: false });
                        }} />
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='form-horizontal form-inline'>
                                    {/* 키워드검색 */}
                                    <SearchSelect
                                        data={strings.const.SEARCH_PRODUCT}
                                        value={search_info.column || strings.const.SEARCH_PRODUCT[0].code}
                                        onChange={(value) => {
                                            this.setState({
                                                search_info: {
                                                    ...search_info,
                                                    column: value,
                                                    start: 0,
                                                }
                                            }, this.searchTable);
                                        }}
                                    />
                                    <SearchInput
                                        value={search_info.keyword}
                                        onChange={(value) => {
                                            this.setState({
                                                search_info: {
                                                    ...search_info,
                                                    keyword: value,
                                                    column: search_info.column || strings.const.SEARCH_PRODUCT[0].code,
                                                    start: 0,
                                                }
                                            })
                                        }}
                                        handler={(value) => this.searchTable()}
                                    />

                                    <button type='button' className='btn btn-success btn-sm ml-md-2' onClick={() => this.searchTable()}>{strings.search}</button>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 mt-3'>
                                <DataTable ref={(ref) => this.tblMember = ref}
                                    customPaginate={true}
                                    initialPage={search_info.start || 0}
                                    onPageChange={(value) => {
                                        this.setState({
                                            search_info: {
                                                ...search_info,
                                                start: value,
                                            }
                                        }, this.searchTable);
                                    }}
                                    options={{
                                        columnDefs: [
                                            {
                                                targets: [columnNo++], data: 'id', orderable: false,
                                                render: function (value) {
                                                    return value;
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'profile_image', orderable: false,
                                                createdCell: function (td, value, item) {
                                                    if (!value) {
                                                        return $(td).html(`(${strings.not_verified})`);
                                                    } else {
                                                        return $(td).image_lightbox(value, () => {
                                                            self.context.showGallery(value.split('#').map((it) => { return Const.BASE_URL + it }))
                                                        });
                                                    }
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'nickname', orderable: false,
                                                createdCell: function (td, value, item) {
                                                    return $(td).nickname_label(value, item.gender, () => {
                                                        self.showMemberDetailPopup(item.uid);
                                                    });
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'user_status', orderable: false,
                                                render: function (value) {
                                                    return Number(value).status2String();
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'main_image', orderable: false,
                                                createdCell: function (td, value, item) {
                                                    return $(td).image_lightbox(value, () => {
                                                        self.context.showGallery([value].concat(item.image_list.split('#')).map((it) => { return Const.BASE_URL + it }))
                                                    });
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'company', orderable: false,
                                                render: function (value) {
                                                    return value;
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'title', orderable: false,
                                                render: function (value) {
                                                    return value;
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'address', orderable: false,
                                                render: function (value) {
                                                    return value;
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'join_status', orderable: false,
                                                render: function (value) {
                                                    if (value == 0) {
                                                        return `<span class="text-black">신청완료</span>`;
                                                    } else if (value == 0) {
                                                        return `<span class="text-danger">참여완료</span>`;
                                                    }
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'create_date', orderable: false,
                                                render: function (value) {
                                                    return value;
                                                }
                                            },
                                        ],
                                        order: [[1, 'DESC']],
                                        ajax: {
                                            url: 'event/getJoinList',
                                            data: function (req) {
                                                req.columns = null;

                                                const searchQS = queryString.parse(self.props.location.search);
                                                req.start = searchQS.start || 0;
                                                req.length = searchQS.length || 20;
                                                req.type = searchQS.type;
                                                req.category = searchQS.category;
                                                req.company = searchQS.company;
                                                req.column = searchQS.column;
                                                req.keyword = searchQS.keyword;
                                            }
                                        },
                                        drawCallback: function () {
                                        },
                                        fnCreatedRow: function (row, data, dataInd) {
                                        }
                                    }}>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>{strings.profile}</th>
                                            <th>{strings.nickname}</th>
                                            <th>{strings.status}</th>
                                            <th>{strings.main_image}</th>
                                            <th>{strings.company}</th>
                                            <th>{strings.title}</th>
                                            <th>{strings.address}</th>
                                            <th>{strings.status}</th>
                                            <th>{strings.create_date}</th>
                                        </tr>
                                    </thead>
                                    <tbody />
                                </DataTable>
                            </div>
                        </div>
                    </PanelBody>
                </Panel>
            </div>
        )
    }
}

export default withRouter(inject('rootStore')(EventJoin));